/**
 * @file
 * Treston search block functionality
 */

  window.addsearch_settings = {
    show_search_suggestions: true
  };

(function ($, Drupal, once) {

  'use strict';

  Drupal.behaviors.trestonSearch = {
    addsearchSessionId: null,
    attach: function (context, settings) {

      $("#block-treston-exposedformaddsearchaddsearch-top .form-text").autocomplete({
        open: function(event, ui) {
          if (navigator.userAgent.match(/(iPod|iPhone|iPad)/)) {
            $('.ui-autocomplete').off('menufocus hover mouseover');
          }
        }
      });

      if(Drupal.behaviors.trestonSearch.addsearchSessionId === null) {
          Drupal.behaviors.trestonSearch.addsearchSessionId = 'session_' + Math.random().toString(36).substr(2, 13);        
      }


      var inputs = $("input.addsearch");
      if(inputs.length > 0) {
        inputs.each(function(){
          var input = $(this);
          input.removeClass('noSearchID');
          input.attr("data-searchSessionId", Drupal.behaviors.trestonSearch.addsearchSessionId);
          input.attr('data-autocomplete-path', input.attr('data-autocomplete-path') + '&userToken=' + Drupal.behaviors.trestonSearch.addsearchSessionId);
        });
      }


      $(once('addsearch-header-button-once', '#block-treston-headersearchbutton', context)).each(function() {
        $("#search-overlay-close").on("click", function(){
            $("#addsearch-form-overlay").removeClass("active");
            $("BODY").removeClass("with-overlay");
            $(document).unbind('keyup.searchButton');
        });
        $("#search-button-image", context).on("click", function() {
          var button = $("#addsearch-form-overlay");
          if(button.hasClass("active")) {
            $("#addsearch-form-overlay").removeClass("active");
            $("BODY").removeClass("with-overlay");
            $(document).unbind('keyup.searchButton')
          }
          else {
            $("#addsearch-form-overlay").addClass("active");
            $("BODY").addClass("with-overlay");
            $(document).on("keyup.searchButton", function(e) {
              if (e.key === "Escape") {
                $("#addsearch-form-overlay").removeClass("active");
                $("BODY").removeClass("with-overlay");
                $(document).unbind('keyup.searchButton')
              } 
            });      
          }
        });
      });

      $(once('addsearch-header-form-once', '#block-treston-exposedformaddsearchaddsearch-top form', context)).each(function() {
        var $form = $(this);

        // Radio button event listeners
        $form.find('input[type=radio]').change(function() {
          // One loader at a time
          $form.find('.loader').remove();
          $(this).siblings('label').append('<div class="loader"></div>');

          // Submit form (setTimeout is for Safari)
          setTimeout(function() {
            $form.find('input.form-submit').trigger('click');
          }, 50);
        });

        $("#block-treston-exposedformaddsearchaddsearch-top").on('click', function() {
          var inputField = $("#block-treston-exposedformaddsearchaddsearch-top INPUT[type=text]");
          //inputField.addClass("expanded");
          //inputField.focus();
          if($("#addsearch-form-overlay").length > 0) {
            return;
          }
          return;
          var newForm = $("#block-treston-exposedformaddsearchaddsearch-top").clone(true);
          newForm.attr("id", "block-treston-exposedformaddsearchaddsearch-overlay");
          var formContainer = $('<div id="addsearch-form-overlay"></div>');
          formContainer.append(newForm);
          var overlay = $("div.search-overlay");
          overlay.append(formContainer);

        })

        // Sorter links
        $('.view-display-id-addsearch_page .sort-wrapper a').each(function() {
          // Current selection
          if($(this).data('value') == $form.find('input[name=sort]:checked').val()) {
            $(this).addClass('active');
          }

          // Sorter event listeners
          $(this).on('click', function(e) {
            e.preventDefault();

            // Mark the corresponding radio button
            var value = $(this).data('value');
            $form.find('input[name=sort][value="'+value+'"]').attr('checked', 'checked');

            // Submit form
            $form.find('input.form-submit').trigger('click');
          });
        });
      });
    }
  };


})(jQuery, Drupal, once);